import { useIsAuthenticated } from '@azure/msal-react'
import {
  AOIPage,
  DashboardPage,
  OrganizationPage,
  QGisPage,
  SigninPage,
  SitePage,
} from './routerLoadables'
import ProtectedRoute from './ProtectedRoute'
import { Navigate } from 'react-router-dom'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import AOIDetails from '../modules/AOI/Details'
import SiteDetails from '../modules/Site/Details'
import useAccessControlHook from '../modules/accessControl/accessControlHook'
import { MODULE_IDS_MAP } from '../modules/accessControl/constants'
import NotFound from '../modules/notFound/notFound'
import { Row, Spin } from 'antd'

function Router() {
  const isLoggedIn = useIsAuthenticated()
  const { hasPermissions, userDataLoading } = useAccessControlHook(MODULE_IDS_MAP.aoiModule)

  return (
    <BrowserRouter basename="/">
      <Routes>
        {/* <Navigate from="/:url*(/+)" to={pathname.slice(0, -1)} /> */}
        {/* <Route path="/:url*(/+)" element={<Navigate to={pathname.slice(0, -1)} /> } /> */}
        <Route
          path="/"
          element={isLoggedIn ? <Navigate to="/site" /> : <Navigate to="/signin" />}
        />
        <Route path="/signin" element={<SigninPage />} />
        {/* <Route
          path="/organization"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/organization/:orgCode"
          element={
            <ProtectedRoute>
              <OrganizationPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/qgis"
          element={
            <ProtectedRoute>
              <QGisPage />
            </ProtectedRoute>
          }
        /> */}

        <Route
          path="/aoi"
          element={
            userDataLoading ? (
              <Row align={'middle'} justify={'center'} style={{ width: '100%', padding: 24 }}>
                <Spin size="large" />
              </Row>
            ) : hasPermissions > 0 ? (
              <ProtectedRoute>
                <AOIPage />
              </ProtectedRoute>
            ) : (
              <ProtectedRoute>
                <NotFound />
              </ProtectedRoute>
            )
          }
        />

        <Route
          path="/aoi/:id"
          element={
            userDataLoading ? (
              <Row align={'middle'} justify={'center'} style={{ width: '100%', padding: 24 }}>
                <Spin size="large" />
              </Row>
            ) : hasPermissions > 0 ? (
              <ProtectedRoute>
                <AOIDetails />
              </ProtectedRoute>
            ) : (
              <ProtectedRoute>
                <NotFound />
              </ProtectedRoute>
            )
          }
        />

        <Route
          path="/site"
          element={
            <ProtectedRoute>
              <SitePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/site/:id"
          element={
            <ProtectedRoute>
              <SiteDetails />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  )
}

export default Router
